import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: {
                primary: {
                    base: '#131c3b',
                    lighten1: "#24305A",
                    darken1: "#0D142B"
                },
                secondary: '#fff',
            }
        }
        
    }
});
